import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        baseUrl: 'apiweb.qqiananan.com'
    },
    getters: {
        token(state) {
            // return state.user.userInfo.token
        }
    },
    mutations: {},
    actions: {},
    plugins: [
        createPersistedState({
            // 配置项，例如过滤掉不想持久化的state
            paths: ['user']
        })
    ]
})
